import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	releasesItem: {
		id: 'spa-apps-sidebar-software-classic.menu.releases-menu-item.releases-item',
		defaultMessage: 'Releases',
		description: 'Releases in a classic software project.',
	},
});
